import { useState, useEffect, useCallback } from 'react';
import apiClient from '../utils/api';

export const useHealthScore = (refreshKey) => {
  const [scoreData, setScoreData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchScore = useCallback(async () => {
    try {
      setLoading(true);
      const response = await apiClient.get('/api/health/score');
      setScoreData(response.data);
    } catch (error) {
      console.error('Error fetching health score:', error);
      setScoreData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchScore();
  }, [fetchScore, refreshKey]);

  return { scoreData, loading, refetch: fetchScore };
};
